import { Group, Stepper, Button as MButton } from "@mantine/core";
import { Button, Modal, Form, Row, Col, Input } from "antd";
import { useState } from "react";
import { AiOutlineCheck } from "react-icons/ai";
import createContact from "../../../../services/createContact";
// import { useCreateSourceMutation } from "../../../store/endpoints/sources";

export default function CreateCustomer({ isVisible, hideModal }: any) {
  const [selected, setSelected] = useState(1);

  const [form] = Form.useForm();

  const onSubmit = async () => {
    const values = await form.validateFields();
    const data = await createContact({ ...values, type: selected });
    hideModal();
  };

  const clearForm = async () => {
    form.resetFields();
  };

  const types = [
    { id: 1, name: "Company" },
    { id: 2, name: "Individual" },
  ];

  return (
    <Modal
      visible={isVisible}
      title="New Booking"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="createBooking"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          // loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="createBooking"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
      >
        <div className="flex flex-row, justify-between"></div>

        <Row gutter={[16, 0]}>
          {types.map((type: any) => (
            <Col xs={{ span: 24 }} lg={{ span: 12 }}>
              <button
                type="button"
                className="flex flex-row  items-center mb-4 border w-full"
                onClick={() => setSelected(type.id)}
              >
                {selected === type.id ? (
                  <div className="h-8 w-8 border-r flex justify-center items-center bg-green-100">
                    <AiOutlineCheck />
                  </div>
                ) : (
                  <div className="h-8 w-8 border-r flex justify-center items-center">
                    <AiOutlineCheck color="#FFFFFF" />
                  </div>
                )}
                <div className="ml-4"></div>
                {type.name}
              </button>
            </Col>
          ))}
        </Row>

        {selected === 1 ? (
          <>
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please enter name",
                    },
                  ]}
                >
                  <Input placeholder="Name" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="address"
                  rules={[
                    {
                      required: true,
                      message: "Please enter address",
                    },
                  ]}
                >
                  <Input placeholder="Address" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please enter email",
                    },
                  ]}
                >
                  <Input placeholder="Email" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="phone"
                  rules={[
                    {
                      required: true,
                      message: "Please enter phone",
                    },
                  ]}
                >
                  <Input placeholder="Phone" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="revenue"
                  rules={[
                    {
                      required: false,
                      message: "Please enter revenue",
                    },
                  ]}
                >
                  <Input placeholder="Revenue (Optional)" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="employees"
                  rules={[
                    {
                      required: false,
                      message: "Please enter employees",
                    },
                  ]}
                >
                  <Input placeholder="Employees (Optional)" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="tin"
                  rules={[
                    {
                      required: false,
                      message: "Please enter TIN",
                    },
                  ]}
                >
                  <Input placeholder="TIN (Optional)" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="vrn"
                  rules={[
                    {
                      required: true,
                      message: "Please enter VRN",
                    },
                  ]}
                >
                  <Input placeholder="VRN (Optional)" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="website"
                  rules={[
                    {
                      required: false,
                      message: "Please enter website",
                    },
                  ]}
                >
                  <Input placeholder="Website (Optional)" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="year"
                  rules={[
                    {
                      required: false,
                      message: "Please enter year",
                    },
                  ]}
                >
                  <Input placeholder="Year (Optional)" />
                </Form.Item>
              </Col>
            </Row>
            <div className="mb-4 flex justify-center items-center font-bold">
              Owner Details
            </div>
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="ownerName"
                  rules={[
                    {
                      required: true,
                      message: "Please enter name",
                    },
                  ]}
                >
                  <Input placeholder="Name" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="ownerAddress"
                  rules={[
                    {
                      required: true,
                      message: "Please enter address",
                    },
                  ]}
                >
                  <Input placeholder="Address" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="ownerEmail"
                  rules={[
                    {
                      required: true,
                      message: "Please enter email",
                    },
                  ]}
                >
                  <Input placeholder="Email" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="ownerPhone"
                  rules={[
                    {
                      required: true,
                      message: "Please enter phone",
                    },
                  ]}
                >
                  <Input placeholder="Phone" />
                </Form.Item>
              </Col>
            </Row>
          </>
        ) : (
          <>
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please enter name",
                    },
                  ]}
                >
                  <Input placeholder="Name" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="address"
                  rules={[
                    {
                      required: true,
                      message: "Please enter address",
                    },
                  ]}
                >
                  <Input placeholder="Address" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please enter email",
                    },
                  ]}
                >
                  <Input placeholder="Email" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <Form.Item
                  name="phone"
                  rules={[
                    {
                      required: true,
                      message: "Please enter phone",
                    },
                  ]}
                >
                  <Input placeholder="Phone" />
                </Form.Item>
              </Col>
            </Row>
          </>
        )}
      </Form>
    </Modal>
  );
}
